import React from 'react'
import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'

const containerVariants = {
  hidden: { opacity: 0, scale: 0.95 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      staggerChildren: 0.3,
      ease: 'easeOut',
      duration: 0.8,
    },
  },
}

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
}

const buttonVariants = {
  hover: {
    scale: 1.05,
    boxShadow: '0px 8px 15px rgba(255, 210, 63, 0.6)',
    transition: {
      duration: 0.3,
      yoyo: Infinity,
      ease: 'easeInOut',
    },
  },
}

const AboutHeadCard = () => {
  const navigate=useNavigate()
  return (
    <motion.div
      className='p-5 md:p-8 bg-gradient-to-tr from-[#ED8B29] to-[#FFD23F] rounded-3xl text-start text-white'
      variants={containerVariants}
      initial='hidden'
      animate='visible'
    >
      <motion.h1
        className='text-4xl font-bold mt-2 mb-4'
        variants={itemVariants}
      >
        Empowering Businesses, Inspiring Innovation
      </motion.h1>

      <motion.p variants={itemVariants}>
        At DevSpots, we specialize in transforming businesses with enterprise-grade software solutions tailored to their needs. With a legacy of technical excellence, a global team of over 2,000 experts, and a passion for innovation, we help organizations thrive in an ever-evolving digital landscape.
      </motion.p>

      <motion.div className='text-end mt-5' variants={itemVariants}>
        <motion.button
          className='text-end m-auto p-3 bg-white rounded-xl text-[#ED8B29] hover:shadow-lg font-medium'
          variants={buttonVariants}
          whileHover='hover'
          onClick={()=>navigate('/contact')}
        >
          Get in Touch
        </motion.button>
      </motion.div>
    </motion.div>
  )
}
export default AboutHeadCard
